import SidebarCustomSections from "../common/custom-sections.gjs";

export default class SidebarAnonymousCustomSections extends SidebarCustomSections {
  anonymous = true;
}
